// Initialize KeenSlider und Thumbnails
document.addEventListener('DOMContentLoaded', function() {
  const sliderElement = document.querySelector('#product-slider');
  if (!sliderElement) return; // 🚨 Stoppt, wenn kein Slider vorhanden ist

  const slider = new KeenSlider(sliderElement, {
    loop: true,
    slidesPerView: 1,
    spacing: 10,
  });

  // Pfeil-Navigation (nur, wenn Buttons existieren)
  const prevBtn = document.getElementById('slider-prev');
  const nextBtn = document.getElementById('slider-next');

  if (prevBtn) {
    prevBtn.addEventListener('click', () => slider.prev());
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => slider.next());
  }

  // Thumbnails click
  const thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => slider.moveToIdx(idx));
  });

  // Aktives Thumbnail setzen
  function setActiveThumb(idx) {
    thumbs.forEach((thumb, i) => {
      thumb.setAttribute('data-active', i === idx);
    });
  }

  slider.on('slideChanged', () => {
    setActiveThumb(slider.track.details.rel);
  });

  // initial
  setActiveThumb(0);
});
